/* No email addresses or form contents enter analytics. */
(() => {
  if (window.CPWelcomeOffer) return;
  window.CPWelcomeOffer = true;
  let confirmed = false;
  function success() {
    if (confirmed || !document.querySelector('[data-cp-newsletter-confirmed]')) return;
    const accepted = window.CPAnalytics?.track('cp_newsletter_signup', { placement: 'welcome_offer', result: 'shopify_accepted' });
    if (accepted) confirmed = true;
  }
  document.addEventListener('submit', e => {
    if (e.target.matches('.cp-welcome-form') && !e.defaultPrevented && e.target.checkValidity()) window.CPAnalytics?.track('cp_newsletter_attempt', { placement: 'welcome_offer' });
  });
  document.addEventListener('click', e => {
    if (e.target.closest('[data-cp-offer-claim]')) window.CPAnalytics?.track('cp_newsletter_offer_claim', { placement: 'welcome_offer' });
  });
  document.addEventListener('DOMContentLoaded', success, { once: true });
  document.addEventListener('visitorConsentCollected', success);
  document.addEventListener('shopify:section:load', success);
  if (document.readyState !== 'loading') success();
})();
